import { type FragmentOf, graphql, readFragment } from "@/graphql"

const graphQLFragments = {
    account: graphql(`
        fragment hasAccountEnergyCheque_Account on AccountType {
            ledgers {
                ledgerType
            }
        }
    `),
}

export function hasAccountEnergyCheque(fragment: FragmentOf<typeof graphQLFragments.account>) {
    const account = readFragment(graphQLFragments.account, fragment)

    return !!account.ledgers?.some((ledger) => ledger?.ledgerType === "ENERGY_CHEQUE_LEDGER")
}

hasAccountEnergyCheque.fragments = graphQLFragments
